<template>
  <div class="group-mine-body">
    <div class="main">
      <div class="group-mine-first-div">
        <div class="group-mine-nav-div">
          <navBar :lefticon="back_icon" :lefticonshow="true" @goback="goBack">
            <template v-slot:title>
              <img :src="mine_title_logo" alt="" class="title-logo">
            </template>
          </navBar>
        </div>
      </div>
      <div class="group-mine-second-div">
        <div>可用余额（元）</div>
        <div>{{Number(spike_balance).toFixed(2)}}</div>
        <div v-show="Number(spike_frozen_amount) !=0"><span>冻结金额</span><span>{{spike_frozen_amount}}</span> </div>
        <div class="widthdraw-btn"><span @click="goPage('/grouprob/panicWithdraw')">提现</span></div>
      </div>
    </div>
    <div class="group-mine-three-div">
      <div @click="order_pup_show=true"><span>{{order_type}}</span><img :src="arrow_down_black" alt=""></div>
      <div @click="time_pup_show=true"><span>{{start_date==''?'全部时间':start_date.replace(/-/g,'.')+ '-'+ end_date.replace(/-/g,'.')}}</span><img :src="arrow_down_black" alt=""></div>
    </div>
    <van-popup v-model="time_pup_show" position="bottom" :style="{ height: '30%' }">
      <van-datetime-picker v-model="startDate" type="date" :default-index="1" :visible-item-count="3" v-show="isshowtime">
        <template v:slot="cancel">
          <div class="btn-cancel" @click="onCancel()">取消</div>
        </template>
        <template v:slot="confirm">
          <div class="btn-confirm" @click="nextstep()">下一步</div>
        </template>
      </van-datetime-picker>
      <van-datetime-picker v-model="endDate" type="date" :default-index="1" :visible-item-count="3" v-show="!isshowtime" :min-date="minDate">
        <template v:slot="cancel">
          <div class="btn-cancel" @click="isshowtime=true">上一步</div>
        </template>
        <template v:slot="confirm">
          <div class="btn-confirm" @click="onConfirm()">完成</div>
        </template>
      </van-datetime-picker>
    </van-popup>
    <!-- <van-dropdown-menu active-color="#F9591B">
      <van-dropdown-item :title="start_date==''?'全部时间':start_date.replace(/-/g,'.')+'-'+end_date.replace(/-/g,'.')" ref="timeitem" class="date__content">

      </van-dropdown-item>
    </van-dropdown-menu> -->

    <div class="group-mine-four-div" :class="{'group-mine-four-div-ios':iosx && Number(spike_frozen_amount) !=0, 'group-mine-four-div-forze':Number(spike_frozen_amount) ==0, 'group-mine-four-div-ios-forze':iosx && Number(spike_frozen_amount) ==0}">
      <van-pull-refresh v-model="refreshisLoading" @refresh="onRefresh">
        <van-list v-model="orderloading" :finished="orderfinished" finished-text="" @load="onLoad" :immediate-check="false">
          <div class="group-mine-order-item" @click="goPage('/grouprob/panicDetail',{relation_order:item.relation_order,id:item.id,balance:item.balance,title:item.title,transaction_type:item.transaction_type,real_title:item.content})" v-for="(item,index) in record_list" :key="index">
            <div><span>{{item.content}}</span><span>{{item.balance.indexOf('-') >= 0 ? Number(item.balance).toFixed(2) : '+' + Number(item.balance).toFixed(2)}}</span></div>
            <div>{{item.create_time}}</div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <grounp-footer path="/grouprob/mine"></grounp-footer>
    <van-popup v-model="order_pup_show" position="bottom" :style="{ height: '45%' }" round>
      <van-picker title="选择收支类型" show-toolbar :columns="columns" @confirm="pupOnConfirm" @cancel="order_pup_show = false" :default-index="0" />
    </van-popup>
    <centerrscreenloading :loading="page_loading" />
  </div>
</template>

<script>
  import navBar from '@/components/nav-bar.vue'
  import grounpFooter from './components/footer.vue'
  import centerrscreenloading from '@/components/centerrscreen-loading.vue'
  import { apiGetFinanceAccountInfo, apiFinanceMembernAccountRecordList } from './api'
  export default {
    components: { navBar, grounpFooter, centerrscreenloading },
    data () {
      return {
        back_icon: require('@/assets/groupRob/back.png'),
        mine_title_logo: require('@/assets/groupRob/mine-title-logo.png'),
        arrow_down_black: require('@/assets/groupRob/arrow-down-black.png'),
        isshowtime: true,
        startDate: new Date(),
        endDate: new Date(),
        start_date: '',
        end_date: '',
        minDate: new Date(),
        time_pup_show: false,
        order_pup_show: false,
        columns: ["全部", '支出', '收入'],
        order_type: "全部",
        spike_balance: 0,
        spike_frozen_amount: 0,
        record_list: [],
        refreshisLoading: false,
        orderloading: false,
        orderfinished: false,
        pagesize: 10,
        page: 1,
        page_loading: true
      }
    },
    async created () {
      this.iosx = this.isIphoneX()
      await apiGetFinanceAccountInfo().then((res) => {
        this.spike_balance = res.spike_balance
        this.spike_frozen_amount = res.spike_frozen_amount
      })
      await this.onRefresh()


    },
    methods: {
      /**
       * @author: shiao
       * @description: 下来刷新事件
       */
      onRefresh () {
        this.page = 0
        this.onLoad()
        this.orderfinished = false
        this.refreshisLoading = false
      },
      onLoad () {
        this.orderloading = true
        this.page_loading = true
        this.page += 1
        const params = { type: 19, page: this.page }
        if (this.start_date) {
          params.start_time = this.start_date
        }
        if (this.end_date) {
          params.end_time = this.end_date
        }
        if (this.order_type != '全部') {
          params.in_ex = this.order_type == '支出' ? 'expend' : 'income'
        }

        apiFinanceMembernAccountRecordList(params).then((res) => {
          this.page_loading = false
          if (this.page == 1) {
            this.record_list = res.list
          } else {
            this.record_list = this.record_list.concat(res.list)
          }
          this.orderloading = false;
          let reslength = res.list ? res.list.length : 0
          if (reslength < this.pagesize) {
            this.orderfinished = true;
          }
        }).catch(() => {
          this.page_loading = false
        })
      },
      onCancel () {
        this.start_date = '';
        this.end_date = '';
        this.refreshing = true;
        this.time_pup_show = false
        this.onRefresh();
      },
      onConfirm () {
        this.end_date = this.formatDate(this.endDate);
        this.isshowtime = true;
        this.refreshing = true;
        this.time_pup_show = false
        this.onRefresh();
      },
      nextstep () {
        this.start_date = this.formatDate(this.startDate);
        this.minDate = new Date(this.start_date.replace(/-/g, '/'))
        this.isshowtime = false
        // console.log(this.start_date, this.minDate, "lllll");
      },
      pupOnConfirm (value) {
        this.order_type = value
        this.order_pup_show = false
        this.onRefresh()
      },
      goPage (path, item) {
        const query = {}
        if (path == '/grouprob/panicWithdraw') {
          query.spike_balance = Number(this.spike_balance).toFixed(2)
        }
        if (path == '/grouprob/panicDetail') {
          query.balance = item.balance
          query.transaction_type = item.transaction_type
          query.ordersn = item.relation_order
          query.id = item.id
          query.title = item.title,
          query.real_title = item.real_title
        }
        this.$router.push({
          path,
          query
        })
      },
      goBack () {
        this.$router.go(-1)
      }
    }
  }
</script>

<style lang="less" scoped>
  .group-mine-body {
    height: 100%;
    overflow: hidden;
    background: #F4F5F6;

    /deep/.van-pull-refresh {
      min-height: 100%;
    }
    // /deep/.van-pull-refresh__track{
    //   overflow-y: auto;
    // }

    .group-mine-first-div {
      height: 310px;
      background-size: 100vw 310px;
      background-image: url('~@/assets/groupRob/mine-top-bg.png');

      .group-mine-nav-div {
        position: fixed;
        top: 0;
        padding-top: 44px;
        left: 0;
        width: 100vw;
      }

      .title-logo {
        height: 32px;
        width: 100px;
        position: relative;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .group-mine-second-div {
      background: #FFFFFF;
      border-radius: 12px;
      width: calc(100vw - 30px);
      position: relative;
      top: -182px;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      overflow: hidden;

      div {
        &:nth-child(1) {
          margin-top: 46px;
          margin-bottom: 3px;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 21px;
        }

        &:nth-child(2) {
          font-size: 36px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 50px;
          margin-bottom: 6px;
        }

        &:nth-child(3) {
          height: 22px;
          background: #F5F6F7;
          border-radius: 15px;
          width: auto;
          display: inline-block;
          padding: 4px 12px;
          margin-bottom: 26px;

          span {
            display: inline-block;

            &:nth-child(1) {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 18px;
              line-height: 22px;
              margin-right: 2px;
            }

            &:nth-child(2) {
              font-size: 13px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.8);
              line-height: 21px;
            }
          }
        }
      }

      .widthdraw-btn {
        span {
          display: inline-block;
          height: 44px;
          background: linear-gradient(90deg, #FF7641 0%, #FF0B40 100%);
          border-radius: 24px;
          line-height: 44px;
          margin: 0 auto 20px;
          width: calc(100% - 130px);
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
        }
      }
    }

    .group-mine-three-div {
      height: 25px;
      margin-top: -162px;
      display: flex;
      padding-left: 15px;

      div {
        padding: 6px 12px;
        background: #FFFFFF;
        border-radius: 15px;
        display: flex;
        align-items: center;
        font-size: 15px;

        img {
          width: 8px;
          height: 4px;
          margin-left: 6px;
        }

        &:nth-child(2) {
          margin-left: 15px;
        }
      }
    }

    .btn-cancel {
      padding-left: 48px;
    }

    .btn-confirm {
      padding-right: 48px;
    }

    .group-mine-four-div {
      margin: 15px;
      height: calc(100vh - 495px);
      overflow-y: auto;

      .group-mine-order-item {
        padding: 15px;
        margin-bottom: 12px;
        background-color: #fff;
        border-radius: 8px;

        div {
          &:nth-child(1) {
            display: flex;
            justify-content: space-between;

            span {
              &:nth-child(1) {
                height: 26px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.8);
                line-height: 26px;
              }

              &:nth-child(2) {
                height: 30px;
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FA8C16;
                line-height: 30px;
              }
            }
          }

          &:nth-child(2) {
            height: 18px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.4);
            line-height: 18px;
            margin-top: 8px;
          }
        }
      }
    }

    .group-mine-four-div-forze {
      height: calc(100vh - 442px);
    }

    .group-mine-four-div-ios {
      height: calc(100vh - 529px);
    }

    .group-mine-four-div-ios-forze {
      height: calc(100vh - 475px);
    }

    .account-pup-title {
      height: 21px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 21px;
      padding: 20px 0 30px 12px;
    }

    .account-item-div {
      padding-left: 12px;
      padding-right: 12px;
      margin-bottom: 22px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
</style>